module.exports = __webpack_public_path__ + "files/3a580b0e37ddf355a3bf7f4e5e3f4f26.svg";